import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"


const record16Api = {
    //查詢展館和對應公司的申請記錄
    "queryRecord16ProductModelByPage": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record16/getRecord16ByPage`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                updatedid: null,  //展馆id
                pageNum: 1,
                pageSize: 10
            }
        }
    },
    "insertAdditionalrecord16": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record16/insertRecord16`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                addinfo1: null,   //產品ID
                addinfo2: null,   //價格
                companycode: null,   //邀請公司的companycode
                updatedid: null,   //展會Id
                historydatetime: null,   //操作時間
            }
        }
    },
    "delAdditionalrecord16": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record16/delAdditionalrecord16`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,   //ID
            }
        }
    },

    "updateRecord16Position": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record16/updateRecord16Position`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,   //ID
            }
        }
    }

}

export default record16Api